import { HTMLInputTypeAttribute, InputHTMLAttributes } from "react";

interface ITextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  type?: HTMLInputTypeAttribute;
}

const TextInput: React.FunctionComponent<ITextInputProps> = (props) => {
  return (
    <input
      className="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10"
      {...props}
    />
  );
};

export default TextInput;
